/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Scope_Point_4Inputs */

const en_svc_n8n_scope_point_4 = /** @type {(inputs: Svc_N8n_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-hosted n8n or n8n Cloud setup, with monitoring`)
};

const lv_svc_n8n_scope_point_4 = /** @type {(inputs: Svc_N8n_Scope_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n uzstādīšana savā serverī vai n8n Cloud ar uzraudzību`)
};

/**
* | output |
* | --- |
* | "Self-hosted n8n or n8n Cloud setup, with monitoring" |
*
* @param {Svc_N8n_Scope_Point_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_scope_point_4 = /** @type {((inputs?: Svc_N8n_Scope_Point_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Scope_Point_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_scope_point_4(inputs)
	return en_svc_n8n_scope_point_4(inputs)
});